import React from "react";
import "date-fns";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Conclusion from "./Conclusion";
import Autocomplete from "./../Autocomplete";
import IconButton from "@material-ui/core/IconButton";
import DescriptionIcon from "@material-ui/icons/Description";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from "@material-ui/pickers";
import Archivos from "./Archivos";
import SnackBar from "../../SnackBar";
const firebase = require("firebase");
require("firebase/firestore");

class Etapa3Oral extends React.Component {
  constructor() {
    super();
    this.state = {
      id: "",
      created: false,
      numExped: "",
      nombNumJuz: "",
      tribunal: "",
      fechaPrestDem: null,
      fechaPrestDemP: [],
      coment1: "",
      fechaRadicDem: null,
      fechaRadicDemP: [],
      coment2: "",
      fechaEmplazam: null,
      fechaEmplazamP: [],
      coment3: "",
      fechaContestDem: null,
      fechaContestDemP: [],
      coment4: "",
      fechaAdmisConte: null,
      fechaAdmisConteP: [],
      coment5: "",
      fechaContVistaConte: null,
      fechaCVCDatabase: null,
      fechaContVistaConteP: [],
      coment6: "",
      fechaAdmisConteVist: null,
      fechaAdmisConteVistP: [],
      coment7: "",
      fechaAudiePrelim: null,
      fechaAPDatabase: null,
      fechaAudiePrelimP: [],
      coment8: "",
      //** Pruebas Desahogo Admite Actora */
      fechaPDConfesional: null,
      fechaPDCDatabase: null,
      fechaPDTestimonial: null,
      fechaPDTDatabase: null,
      fechaPDDecParte: null,
      fechaPDDPDatabase: null,
      fechaPDDecTercero: null,
      fechaPDDTDatabase: null,
      fechaPDPericial: null,
      fechaPDPDatabase: null,
      fechaPDInspJudic: null,
      fechaPDIJDatabase: null,
      fechaPDRecHechos: null,
      fechaPDRHDatabase: null,
      fechaPDRatifContFir: null,
      fechaPDRCFDatabase: null,
      ////////////////////////
      fechaAudieJuicio: null,
      fechaAJDatabse: null,
      fechaAudieJuicioP: [],
      coment9: "",
      //** Pruebas Desahogo Admite Demanda */
      fechaPD2Confesional: null,
      fechaPD2CDatabase: null,
      fechaPD2Testimonial: null,
      fechaPD2TDatabase: null,
      fechaPD2DecParte: null,
      fechaPD2DPDatabase: null,
      fechaPD2DecTercero: null,
      fechaPD2DTDatabase: null,
      fechaPD2Pericial: null,
      fechaPD2PDatabase: null,
      fechaPD2InspJudic: null,
      fechaPD2IJDatabase: null,
      fechaPD2RecHechos: null,
      fechaPD2RHDatabase: null,
      fechaPD2RatifContFir: null,
      fechaPD2RCFDatabase: null,
      //************** */
      fechaSentencia: null,
      fechaSentenciaP: [],
      coment10: "",
      filterCitaSent: false,
      fechaPrestAmpar: null,
      fechaPADatabase: null,
      fechaPrestAmparP: [],
      coment11: "",
      fechaEjecuAmpar: null,
      filterEjecAmp: false,
      fechaEjecuAmparP: [],
      coment12: "",
      fechaCumplim: null,
      fechaCumplimP: [],
      coment13: "",
      resumenResol: "",
      resumenResolP: [],
      fechaCumplim2: null,
      fechaCumplim2P: [],
      coment14: "",
      otrosResum: "",
      otrosResumP: [],
      descr: "",
      open: false,
      guardado: false,
      openPdf: false,
      archivoState: null,
      lista: ""
    };
    this.handlePrestDem = this.handlePrestDem.bind(this);
    this.handleRadicDeman = this.handleRadicDeman.bind(this);
    this.handleEmplaza = this.handleEmplaza.bind(this);
    this.handleContestDeman = this.handleContestDeman.bind(this);
    this.handleAdmisiContest = this.handleAdmisiContest.bind(this);
    this.handleContestVistContest = this.handleContestVistContest.bind(this);
    this.handleAdisiContestLitis = this.handleAdisiContestLitis.bind(this);
    this.handleAudienPrel = this.handleAudienPrel.bind(this);

    this.handlePDConfesional = this.handlePDConfesional.bind(this);
    this.handlePDTestimonial = this.handlePDTestimonial.bind(this);
    this.handlePDDecParte = this.handlePDDecParte.bind(this);
    this.handlePDDecTercero = this.handlePDDecTercero.bind(this);
    this.handlePDPericial = this.handlePDPericial.bind(this);
    this.handlePDInspJudic = this.handlePDInspJudic.bind(this);
    this.handlePDRecHechos = this.handlePDRecHechos.bind(this);
    this.handlePDRatifContFir = this.handlePDRatifContFir.bind(this);

    this.handleAudiJuic = this.handleAudiJuic.bind(this);

    this.handlePD2Confesional = this.handlePD2Confesional.bind(this);
    this.handlePD2Testimonial = this.handlePD2Testimonial.bind(this);
    this.handlePD2DecParte = this.handlePD2DecParte.bind(this);
    this.handlePD2DecTercero = this.handlePD2DecTercero.bind(this);
    this.handlePD2Pericial = this.handlePD2Pericial.bind(this);
    this.handlePD2InspJudic = this.handlePD2InspJudic.bind(this);
    this.handlePD2RecHechos = this.handlePD2RecHechos.bind(this);
    this.handlePD2RatifContFir = this.handlePD2RatifContFir.bind(this);

    this.handlePresentAmp = this.handlePresentAmp.bind(this);
    this.handleSentencia = this.handleSentencia.bind(this);
    this.handleEjecAmpa = this.handleEjecAmpa.bind(this);
    this.handleCumpliment = this.handleCumpliment.bind(this);
    this.handleCumpliment2 = this.handleCumpliment2.bind(this);
  }

  componentDidMount = async () => {
    //const notaSeleccionada = await this.props.notes[this.props.index];
    if (this.props.selectedNote.fase3O) {
      const notaSeleccionada = await this.props.notes.filter(
        i => i.id === this.props.selectedNote.id
      )[0];

      await this.fullFields(notaSeleccionada.fase3O);
    }
  };

  fullFields = data => {
    this.setState({
      id: data.id,
      numExped: data.numExped,
      nombNumJuz: data.nombNumJuz,
      tribunal: data.tribunal,
      fechaPrestDem: data.fechaPrestDem ? data.fechaPrestDem.toDate() : null,
      fechaPrestDemP: data.fechaPrestDemP,
      coment1: data.coment1,
      fechaRadicDem: data.fechaRadicDem ? data.fechaRadicDem.toDate() : null,
      fechaRadicDemP: data.fechaRadicDemP,
      coment2: data.coment2,
      fechaEmplazam: data.fechaEmplazam ? data.fechaEmplazam.toDate() : null,
      fechaEmplazamP: data.fechaEmplazamP,
      coment3: data.coment3,
      fechaContestDem: data.fechaContestDem
        ? data.fechaContestDem.toDate()
        : null,
      fechaContestDemP: data.fechaContestDemP,
      coment4: data.coment4,
      fechaAdmisConte: data.fechaAdmisConte
        ? data.fechaAdmisConte.toDate()
        : null,
      fechaAdmisConteP: data.fechaAdmisConteP,
      coment5: data.coment5,
      fechaContVistaConte: data.fechaContVistaConte
        ? data.fechaContVistaConte.toDate()
        : null,
      fechaContVistaConteP: data.fechaContVistaConteP,
      coment6: data.coment6,
      fechaAdmisConteVist: data.fechaAdmisConteVist
        ? data.fechaAdmisConteVist.toDate()
        : null,
      fechaAdmisConteVistP: data.fechaAdmisConteVistP,
      coment7: data.coment7,
      fechaAudiePrelim: data.fechaAudiePrelim
        ? data.fechaAudiePrelim.toDate()
        : null,
      fechaAudiePrelimP: data.fechaAudiePrelimP,
      coment8: data.coment8,
      fechaAudieJuicio: data.fechaAudieJuicio
        ? data.fechaAudieJuicio.toDate()
        : null,
      fechaAudieJuicioP: data.fechaAudieJuicioP,
      coment9: data.coment9,
      fechaPDConfesional: data.fechaPDConfesional
        ? data.fechaPDConfesional.toDate()
        : null,
      fechaPDTestimonial: data.fechaPDTestimonial
        ? data.fechaPDTestimonial.toDate()
        : null,
      fechaPDDecParte: data.fechaPDDecParte
        ? data.fechaPDDecParte.toDate()
        : null,
      fechaPDDecTercero: data.fechaPDDecTercero
        ? data.fechaPDDecTercero.toDate()
        : null,
      fechaPDPericial: data.fechaPDPericial
        ? data.fechaPDPericial.toDate()
        : null,
      fechaPDInspJudic: data.fechaPDInspJudic
        ? data.fechaPDInspJudic.toDate()
        : null,
      fechaPDRecHechos: data.fechaPDRecHechos
        ? data.fechaPDRecHechos.toDate()
        : null,
      fechaPDRatifContFir: data.fechaPDRatifContFir
        ? data.fechaPDRatifContFir.toDate()
        : null,
      fechaSentencia: data.fechaSentencia ? data.fechaSentencia.toDate() : null,
      fechaSentenciaP: data.fechaSentenciaP,
      coment10: data.coment10,
      filterCitaSent: this.props.selectedNote.filterCitaSent,
      fechaPD2Confesional: data.fechaPD2Confesional
        ? data.fechaPD2Confesional.toDate()
        : null,
      fechaPD2Testimonial: data.fechaPD2Testimonial
        ? data.fechaPD2Testimonial.toDate()
        : null,
      fechaPD2DecParte: data.fechaPD2DecParte
        ? data.fechaPD2DecParte.toDate()
        : null,
      fechaPD2DecTercero: data.fechaPD2DecTercero
        ? data.fechaPD2DecTercero.toDate()
        : null,
      fechaPD2Pericial: data.fechaPD2Pericial
        ? data.fechaPD2Pericial.toDate()
        : null,
      fechaPD2InspJudic: data.fechaPD2InspJudic
        ? data.fechaPD2InspJudic.toDate()
        : null,
      fechaPD2RecHechos: data.fechaPD2RecHechos
        ? data.fechaPD2RecHechos.toDate()
        : null,
      fechaPD2RatifContFir: data.fechaPD2RatifContFir
        ? data.fechaPD2RatifContFir.toDate()
        : null,
      fechaPrestAmpar: data.fechaPrestAmpar
        ? data.fechaPrestAmpar.toDate()
        : null,
      fechaPrestAmparP: data.fechaPrestAmparP,
      coment11: data.coment11,
      fechaEjecuAmpar: data.fechaEjecuAmpar
        ? data.fechaEjecuAmpar.toDate()
        : null,
      filterEjecAmp: this.props.selectedNote.filterEjecAmp,
      fechaEjecuAmparP: data.fechaEjecuAmparP,
      coment12: data.coment12,
      fechaCumplim: data.fechaCumplim ? data.fechaCumplim.toDate() : null,
      fechaCumplimP: data.fechaCumplimP,
      coment13: data.coment13,
      resumenResol: data.resumenResol,
      resumenResolP: data.resumenResolP,
      fechaCumplim2: data.fechaCumplim2 ? data.fechaCumplim2.toDate() : null,
      fechaCumplim2P: data.fechaCumplim2P,
      coment14: data.coment14,
      otrosResum: data.otrosResum,
      otrosResumP: data.otrosResumP,
      descr: ""
    });
  };

  handlePrestDem(date) {
    this.setState({ fechaPrestDem: date });
  }
  handleRadicDeman(date) {
    this.setState({ fechaRadicDem: date });
  }
  handleEmplaza(date) {
    this.setState({ fechaEmplazam: date });
  }
  handleContestDeman(date) {
    this.setState({ fechaContestDem: date });
  }
  handleAdmisiContest(date) {
    this.setState({ fechaAdmisConte: date });
  }
  handleContestVistContest(date) {
    this.setState({ fechaContVistaConte: date, fechaCVCDatabase: date });
  }
  handleAdisiContestLitis(date) {
    this.setState({ fechaAdmisConteVist: date });
  }
  handleAudienPrel(date) {
    this.setState({ fechaAudiePrelim: date, fechaAPDatabase: date });
  }
  handlePDConfesional(date) {
    this.setState({ fechaPDConfesional: date, fechaPDCDatabase: date });
  }
  handlePDTestimonial(date) {
    this.setState({ fechaPDTestimonial: date, fechaPDTDatabase: date });
  }
  handlePDDecParte(date) {
    this.setState({ fechaPDDecParte: date, fechaPDDPDatabase: date });
  }
  handlePDDecTercero(date) {
    this.setState({ fechaPDDecTercero: date, fechaPDDTDatabase: date });
  }
  handlePDPericial(date) {
    this.setState({ fechaPDPericial: date, fechaPDPDatabase: date });
  }
  handlePDInspJudic(date) {
    this.setState({ fechaPDInspJudic: date, fechaPDIJDatabase: date });
  }
  handlePDRecHechos(date) {
    this.setState({ fechaPDRecHechos: date, fechaPDRHDatabase: date });
  }
  handlePDRatifContFir(date) {
    this.setState({ fechaPDRatifContFir: date, fechaPDRCFDatabase: date });
  }
  handleAudiJuic(date) {
    this.setState({ fechaAudieJuicio: date, fechaAJDatabse: date });
  }
  handlePD2Confesional(date) {
    this.setState({ fechaPD2Confesional: date, fechaPD2CDatabase: date });
  }
  handlePD2Testimonial(date) {
    this.setState({ fechaPD2Testimonial: date, fechaPD2TDatabase: date });
  }
  handlePD2DecParte(date) {
    this.setState({ fechaPD2DecParte: date, fechaPD2DPDatabase: date });
  }
  handlePD2DecTercero(date) {
    this.setState({ fechaPD2DecTercero: date, fechaPD2DTDatabase: date });
  }
  handlePD2Pericial(date) {
    this.setState({ fechaPD2Pericial: date, fechaPD2PDatabase: date });
  }
  handlePD2InspJudic(date) {
    this.setState({ fechaPD2InspJudic: date, fechaPD2IJDatabase: date });
  }
  handlePD2RecHechos(date) {
    this.setState({ fechaPD2RecHechos: date, fechaPD2RHDatabase: date });
  }
  handlePD2RatifContFir(date) {
    this.setState({ fechaPD2RatifContFir: date, fechaPD2RCFDatabase: date });
  }

  handleSentencia(date) {
    this.setState({ fechaSentencia: date, filterCitaSent: true });
  }
  handlePresentAmp(date) {
    this.setState({ fechaPrestAmpar: date, fechaPADatabase: date });
  }
  handleEjecAmpa(date) {
    this.setState({ fechaEjecuAmpar: date, filterEjecAmp: true });
  }
  handleCumpliment(date) {
    this.setState({ fechaCumplim: date });
  }
  handleCumpliment2(date) {
    this.setState({ fechaCumplim2: date });
  }

  render() {
    const { datosAutoc } = this.props;
    return (
      <div>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid //direction="column" justify="flex-start" alignItems="flex-start"
          >
            <div style={{ width: "100%", display: "flex" }}>
              <TextField
                style={{ width: "25%", marginRight: "10px" }}
                id="outlined-name"
                label="Numero del Expediente"
                value={this.state.numExped}
                onChange={e => this.setState({ numExped: e.target.value })}
                margin="normal"
                variant="outlined"
              />

              {/*<TextField
              id="outlined-name"
              label="Nombre del juzgado"
              value={this.state.nombNumJuz}
              onChange={e => this.setState({ nombNumJuz: e.target.value })}
              margin="normal"
              variant="outlined"
            />*/}
              <Autocomplete
                update={this.updateJuzgado}
                datosAutoc={
                  datosAutoc
                    ? datosAutoc.filter(
                        i => i.seccion === "juzgados" && i.activo
                      )
                    : null
                }
                onCloseAutocomplete={this.onCloseAutocompleteJuzgado}
                text={this.state.nombNumJuz}
                nameFiled={"Nombre del juzgado"}
              />
              <Autocomplete
                update={this.updateTribunales}
                datosAutoc={
                  datosAutoc
                    ? datosAutoc.filter(
                        i => i.seccion === "tribunales" && i.activo
                      )
                    : null
                }
                onCloseAutocomplete={this.onCloseAutocompleteTribunales}
                text={this.state.tribunal}
                nameFiled={"Tribunal"}
              />
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Prst. de Demanda"
                value={this.state.fechaPrestDem}
                onChange={this.handlePrestDem}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaPrestDemP"
                key="fechaPrestDemP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaPrestDemP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaPrestDemP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment1}
                onChange={e =>
                  this.setState({
                    coment1: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",
                  textTransform: "none"
                }}
              />
              {/*<Button
                onClick={() => this.pdfAction("fechaPrestDemP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>*/}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Radic. Demanda"
                value={this.state.fechaRadicDem}
                onChange={this.handleRadicDeman}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaRadicDemP"
                key="fechaRadicDemP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaRadicDemP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaRadicDemP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment2}
                onChange={e =>
                  this.setState({
                    coment2: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",
                  textTransform: "none"
                }}
              />
              {/*<Button
                onClick={() => this.pdfAction("fechaRadicDemP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>*/}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Emplazamiento"
                value={this.state.fechaEmplazam}
                onChange={this.handleEmplaza}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaEmplazamP"
                key="fechaEmplazamP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaEmplazamP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaEmplazamP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment3}
                onChange={e =>
                  this.setState({
                    coment3: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",
                  textTransform: "none"
                }}
              />
              {/*<Button
                onClick={() => this.pdfAction("fechaEmplazamP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>*/}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Contest. Demanda"
                value={this.state.fechaContestDem}
                onChange={this.handleContestDeman}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaContestDemP"
                key="fechaContestDemP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaContestDemP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaContestDemP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment4}
                onChange={e =>
                  this.setState({
                    coment4: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",
                  textTransform: "none"
                }}
              />
              {/*<Button
                onClick={() => this.pdfAction("fechaContestDemP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>*/}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Admis. Contest. Demanda"
                value={this.state.fechaAdmisConte}
                onChange={this.handleAdmisiContest}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaAdmisConteP"
                key="fechaAdmisConteP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaAdmisConteP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaAdmisConteP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment5}
                onChange={e =>
                  this.setState({
                    coment5: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",
                  textTransform: "none"
                }}
              />
              {/*<Button
                onClick={() => this.pdfAction("fechaAdmisConteP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>*/}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Contest. Vista Contest."
                value={this.state.fechaContVistaConte}
                onChange={this.handleContestVistContest}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaContVistaConteP"
                key="fechaContVistaConteP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaContVistaConteP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaContVistaConteP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment6}
                onChange={e =>
                  this.setState({
                    coment6: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",
                  textTransform: "none"
                }}
              />
              {/*<Button
                onClick={() => this.pdfAction("fechaContVistaConteP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>*/}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Admis. Contest. Vista..."
                value={this.state.fechaAdmisConteVist}
                onChange={this.handleAdisiContestLitis}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaAdmisConteVistP"
                key="fechaAdmisConteVistP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaAdmisConteVistP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaAdmisConteVistP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment7}
                onChange={e =>
                  this.setState({
                    coment7: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",
                  textTransform: "none"
                }}
              />
              {/*<Button
                onClick={() => this.pdfAction("fechaAdmisConteVistP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>*/}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Audiencia Preliminar"
                value={this.state.fechaAudiePrelim}
                onChange={this.handleAudienPrel}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaAudiePrelimP"
                key="fechaAudiePrelimP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaAudiePrelimP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaAudiePrelimP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment8}
                onChange={e =>
                  this.setState({
                    coment8: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",
                  textTransform: "none"
                }}
              />
              {/*<Button
                onClick={() => this.pdfAction("fechaAudiePrelimP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>*/}
            </div>

            <h3>Fechas de pruebas a Desahogar (Admite Actora)</h3>
            <div>
              <KeyboardDatePicker
                style={{ marginLeft: "5px", marginRight: "5px" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Confesional"
                value={this.state.fechaPDConfesional}
                onChange={this.handlePDConfesional}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />

              <KeyboardDatePicker
                style={{ marginLeft: "5px", marginRight: "5px" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Testimonial"
                value={this.state.fechaPDTestimonial}
                onChange={this.handlePDTestimonial}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />

              <KeyboardDatePicker
                style={{ marginLeft: "5px", marginRight: "5px" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Declaracion de Parte"
                value={this.state.fechaPDDecParte}
                onChange={this.handlePDDecParte}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />

              <KeyboardDatePicker
                style={{ marginLeft: "5px", marginRight: "5px" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Declaracion de Tercero"
                value={this.state.fechaPDDecTercero}
                onChange={this.handlePDDecTercero}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />

              <KeyboardDatePicker
                style={{ marginLeft: "5px", marginRight: "5px" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Pericial"
                value={this.state.fechaPDPericial}
                onChange={this.handlePDPericial}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />

              <KeyboardDatePicker
                style={{ marginLeft: "5px", marginRight: "5px" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Inspeccion Judicial"
                value={this.state.fechaPDInspJudic}
                onChange={this.handlePDInspJudic}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />

              <KeyboardDatePicker
                style={{ marginLeft: "5px", marginRight: "5px" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Reconstruccion de Hechos"
                value={this.state.fechaPDRecHechos}
                onChange={this.handlePDRecHechos}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />

              <KeyboardDatePicker
                style={{ marginLeft: "5px", marginRight: "5px" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Ratificacion Contenido y Firma"
                value={this.state.fechaPDRatifContFir}
                onChange={this.handlePDRatifContFir}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
            </div>
            <br />
            <br />

            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Audiencia Juicio"
                value={this.state.fechaAudieJuicio}
                onChange={this.handleAudiJuic}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaAudieJuicioP"
                key="fechaAudieJuicioP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaAudieJuicioP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaAudieJuicioP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment9}
                onChange={e =>
                  this.setState({
                    coment9: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",
                  textTransform: "none"
                }}
              />
              {/*<Button
                onClick={() => this.pdfAction("fechaAudieJuicioP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>*/}
            </div>
            <h3>Fechas de pruebas a Desahogar (Admite Demanda)</h3>
            <div>
              <KeyboardDatePicker
                style={{ marginLeft: "5px", marginRight: "5px" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Confesional"
                value={this.state.fechaPD2Confesional}
                onChange={this.handlePD2Confesional}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <KeyboardDatePicker
                style={{ marginLeft: "5px", marginRight: "5px" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Testimonial"
                value={this.state.fechaPD2Testimonial}
                onChange={this.handlePD2Testimonial}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <KeyboardDatePicker
                style={{ marginLeft: "5px", marginRight: "5px" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Declaracion de Parte"
                value={this.state.fechaPD2DecParte}
                onChange={this.handlePD2DecParte}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <KeyboardDatePicker
                style={{ marginLeft: "5px", marginRight: "5px" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Declaracion de Tercero"
                value={this.state.fechaPD2DecTercero}
                onChange={this.handlePD2DecTercero}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <KeyboardDatePicker
                style={{ marginLeft: "5px", marginRight: "5px" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Pericial"
                value={this.state.fechaPD2Pericial}
                onChange={this.handlePD2Pericial}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <KeyboardDatePicker
                style={{ marginLeft: "5px", marginRight: "5px" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Inspeccion Judicial"
                value={this.state.fechaPD2InspJudic}
                onChange={this.handlePD2InspJudic}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />

              <KeyboardDatePicker
                style={{ marginLeft: "5px", marginRight: "5px" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Reconstruccion de Hechos"
                value={this.state.fechaPD2RecHechos}
                onChange={this.handlePD2RecHechos}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />

              <KeyboardDatePicker
                style={{ marginLeft: "5px", marginRight: "5px" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Ratificacion Contenido y Firma"
                value={this.state.fechaPD2RatifContFir}
                onChange={this.handlePD2RatifContFir}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
            </div>
            <br />
            <br />
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Sentencia"
                value={this.state.fechaSentencia}
                onChange={this.handleSentencia}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaSentenciaP"
                key="fechaSentenciaP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaSentenciaP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaSentenciaP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment10}
                onChange={e =>
                  this.setState({
                    coment10: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",
                  textTransform: "none"
                }}
              />
              {/*<Button
                onClick={() => this.pdfAction("fechaSentenciaP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>*/}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="*Present. Amparo"
                value={this.state.fechaPrestAmpar}
                onChange={this.handlePresentAmp}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaPrestAmparP"
                key="fechaPrestAmparP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaPrestAmparP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaPrestAmparP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment11}
                onChange={e =>
                  this.setState({
                    coment11: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",
                  textTransform: "none"
                }}
              />
              {/*<Button
                onClick={() => this.pdfAction("fechaPrestAmparP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>*/}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Ejecutoria Amparo"
                value={this.state.fechaEjecuAmpar}
                onChange={this.handleEjecAmpa}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaEjecuAmparP"
                key="fechaEjecuAmparP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaEjecuAmparP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaEjecuAmparP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment12}
                onChange={e =>
                  this.setState({
                    coment12: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",
                  textTransform: "none"
                }}
              />
              {/*<Button
                onClick={() => this.pdfAction("fechaEjecuAmparP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>*/}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Cumplimentadora"
                value={this.state.fechaCumplim}
                onChange={this.handleCumpliment}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaCumplimP"
                key="fechaCumplimP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaCumplimP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaCumplimP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment13}
                onChange={e =>
                  this.setState({
                    coment13: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",
                  textTransform: "none"
                }}
              />
              {/*<Button
                onClick={() => this.pdfAction("fechaCumplimP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary" 
              >
                Archivos
              </Button>*/}
            </div>
            <div>
              <KeyboardDatePicker
                style={{ visibility: "hidden" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label=""
                value={null}
                onChange={null}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="resumenResolP"
                key="resumenResolP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="resumenResolP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("resumenResolP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Resumen de Resolutivos"
                margin="normal"
                value={this.state.resumenResol}
                onChange={e => this.setState({ resumenResol: e.target.value })}
                variant="outlined"
                style={{
                  width: "420px",
                  textTransform: "none"
                }}
              />
              {/*<Button
                onClick={() => this.pdfAction("resumenResolP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>*/}
            </div>
            <div>
              <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label="Cumplimentadora"
                value={this.state.fechaCumplim2}
                onChange={this.handleCumpliment2}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="fechaCumplim2P"
                key="fechaCumplim2P"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="fechaCumplim2P">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("fechaCumplim2P")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Comentario"
                margin="normal"
                value={this.state.coment14}
                onChange={e =>
                  this.setState({
                    coment14: e.target.value,
                    descr: e.target.value
                  })
                }
                variant="outlined"
                style={{
                  width: "420px",
                  textTransform: "none"
                }}
              />
              {/*<Button
                onClick={() => this.pdfAction("fechaCumplim2P")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>*/}
            </div>
            <div>
              <KeyboardDatePicker
                style={{ visibility: "hidden" }}
                disableToolbar
                variant="inline"
                format="dd/MM/yyyy"
                margin="normal"
                id="date-picker-inline"
                label=""
                value={null}
                onChange={null}
                KeyboardButtonProps={{
                  "aria-label": "change date"
                }}
              />
              <input
                disabled={!window.respuesta.checkedF}
                accept="application/pdf"
                style={{ display: "none" }}
                id="otrosResumP"
                key="otrosResumP"
                multiple
                type="file"
                onChange={this.onChangeHandler}
              />
              <label htmlFor="otrosResumP">
                <Button
                  disabled={!window.respuesta.checkedF}
                  variant="contained"
                  component="span"
                  style={{ margin: "20px", textTransform: "none" }}
                >
                  Cargar archivo
                </Button>
              </label>
              <IconButton
                onClick={() => this.pdfAction("otrosResumP")}
                // edge="end"
              >
                <DescriptionIcon />
              </IconButton>
              <TextField
                id="outlined-name"
                label="Otros, Resumenes"
                margin="normal"
                value={this.state.otrosResum}
                onChange={e => this.setState({ otrosResum: e.target.value })}
                variant="outlined"
                style={{
                  width: "420px",
                  textTransform: "none"
                }}
              />
              {/*<Button
                onClick={() => this.pdfAction("otrosResumP")}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Archivos
              </Button>*/}
            </div>
          </Grid>
        </MuiPickersUtilsProvider>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end"
          }}
        >
          {window.respuesta.checkedC ? (
            <>
              <Button
                onClick={this.consluir}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Concluir
              </Button>
              <Button
                onClick={this.save}
                style={{ margin: "6px" }}
                variant="contained"
                color="primary"
              >
                Guardar
              </Button>
            </>
          ) : null}
        </div>
        <div>
          <Dialog
            open={this.state.open}
            onClose={this.consluir}
            aria-labelledby="form-dialog-title"
          >
            <Conclusion
              consluir={this.consluir}
              descr={this.state.descr}
              guardarConclusion={this.guardarConclusion}
              text={"Motivo de Conclusion"}
              setDescr={this.setDescr}
            />
          </Dialog>
        </div>
        <Archivos
          lista={this.state.lista}
          abrir={this.state.openPdf}
          cerrar={this.cerrar}
          eliminar={this.eliminarAr}
        />
        {this.state.guardado && (
          <SnackBar
            open={this.state.guardado}
            handleClick={this.handleClick}
            handleClose={this.handleClose}
          />
        )}
      </div>
    );
  }
  cerrar = () => {
    this.setState({ openPdf: !this.state.openPdf });
  };

  eliminarAr = (archivo, url, nombre) => {
    const y = "fase3M." + this.state.gui;
    const x = {
      [y]: firebase.firestore.FieldValue.arrayRemove({
        bucket: archivo,
        nombre: nombre,
        url: url
      })
    };

    const datosFiltrados = this.state.lista.filter(i => {
      return i.nombre !== nombre;
    });

    this.setState({ lista: datosFiltrados });
    this.setState({ [this.state.gui]: datosFiltrados });

    firebase
      .firestore()
      .collection("notes")
      .doc(this.props.selectedNote.id)
      .update(x);
  };

  pdfAction = gui => {
    this.setState({ gui: gui });
    switch (gui) {
      case "fechaPrestDemP":
        this.setState({ lista: this.state.fechaPrestDemP });
        break;
      case "fechaRadicDemP":
        this.setState({ lista: this.state.fechaRadicDemP });
        break;
      case "fechaEmplazamP":
        this.setState({ lista: this.state.fechaEmplazamP });
        break;
      case "fechaContestDemP":
        this.setState({ lista: this.state.fechaContestDemP });
        break;
      case "fechaAdmisConteP":
        this.setState({ lista: this.state.fechaAdmisConteP });
        break;
      case "fechaContVistaConteP":
        this.setState({ lista: this.state.fechaContVistaConteP });
        break;
      case "fechaAdmisConteVistP":
        this.setState({ lista: this.state.fechaAdmisConteVistP });
        break;
      case "fechaAudiePrelimP":
        this.setState({ lista: this.state.fechaAudiePrelimP });
        break;
      case "fechaAudieJuicioP":
        this.setState({ lista: this.state.fechaAudieJuicioP });
        break;
      case "fechaSentenciaP":
        this.setState({ lista: this.state.fechaSentenciaP });
        break;
      case "fechaPrestAmparP":
        this.setState({ lista: this.state.fechaPrestAmparP });
        break;
      case "fechaEjecuAmparP":
        this.setState({ lista: this.state.fechaEjecuAmparP });
        break;
      case "fechaCumplimP":
        this.setState({ lista: this.state.fechaCumplimP });
        break;
      case "resumenResolP":
        this.setState({ lista: this.state.resumenResolP });
        break;
      case "fechaCumplim2P":
        this.setState({ lista: this.state.fechaCumplim2P });
        break;
      case "otrosResumP":
        this.setState({ lista: this.state.otrosResumP });
        break;
      default:
        console.log("algo salio mal");
    }
    this.setState({ openPdf: !this.state.openPdf });
  };
  handleClose = () => {
    this.setState({ guardado: !this.state.guardado });
  };
  handleClick = () => {
    this.setState({ guardado: !this.state.guardado });
  };
  consluir = () => {
    this.setState({ open: !this.state.open });
  };
  updateJuzgado = async val => {
    await this.setState({ nombNumJuz: val });
    // this.update()
  };
  updateTribunales = async val => {
    await this.setState({ tribunal: val });
    // this.update()
  };
  onCloseAutocompleteJuzgado = () => {};

  onCloseAutocompleteTribunales = () => {};
  guardarConclusion = async () => {
    await firebase
      .firestore()
      .collection("notes")
      .doc(this.props.selectedNote.id)
      .update({
        estado: 3,
        descr: this.state.descr,
        etapa: "3-Oral",
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      });
    this.setState({ open: !this.state.open });
    this.handleClick();
  };
  setDescr = e => {
    this.setState({ descr: e.target.value });
  };
  save = async () => {
    await firebase
      .firestore()
      .collection("notificaciones")
      .add({
        text: `${this.props.selectedNote.name} ha actualizado el caso #${this.props.selectedNote.title}`,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      })
      .then(doc => console.log("notificacion", doc));
    if (this.state.fechaCVCDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idCVCD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Contestacion de vista a la Contestacion de Demanda`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaCVCDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaAPDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idAPD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Audiencia Preliminar`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaAPDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaPDCDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idPDCD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Pruebas de Desahogo Confesional(Actora)`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaPDCDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaPDTDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idPDTD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Pruebas de Desahogo Testimonial(Actora)`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaPDTDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaPDDPDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idPDDPD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Pruebas de Desahogo Declaracion de Parte(Actora)`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaPDDPDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaPDDTDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idPDDTD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Pruebas de Desahogo Declaracion de Tercero(Actora)`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaPDDTDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaPDPDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idPDPD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Pruebas de Desahogo Pericial(Actora)`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaPDPDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaPDIJDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idPDIJD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Pruebas de Desahogo Inspeccion Judicial(Actora)`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaPDIJDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaPDRHDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idPDRHD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Pruebas de Desahogo Reconstruccion de Hechos(Actora)`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaPDRHDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaPDRCFDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idPDRCFD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Pruebas de Desahogo Ratificacion de Contenido y Firma(Actora)`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaPDRCFDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }

    if (this.state.fechaAJDatabse) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idAJD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Audiencia de Juicio(Desahogo de Pruebas)`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaAJDatabse,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaPD2CDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idPD2CD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Pruebas de Desahogo Confesional(Demanda)`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaPD2CDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaPD2TDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idPD2TD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Pruebas de Desahogo Testimonial(Demanda)`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaPD2TDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaPD2DPDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idPD2DPD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Pruebas de Desahogo Declaracion de Parte(Demanda)`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaPD2DPDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaPD2DTDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idPD2DTD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Pruebas de Desahogo Declaracion de Tercero(Demanda)`,
          fecha: this.state.fechaPD2DTDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaPD2PDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idPD2PD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Pruebas de Desahogo Pericial(Demanda)`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaPD2PDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaPD2IJDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idPD2IJD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Pruebas de Desahogo Inspeccion Judicial(Demanda)`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaPD2IJDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaPD2RHDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idPD2RHD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Pruebas de Desahogo Reconstruccion de Hechos(Demanda)`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaPD2RHDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaPD2RCFDatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idPD2RCFD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Pruebas de Desahogo Ratificacion de Contenido y Firma(Demanda)`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaPD2RCFDatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    if (this.state.fechaPADatabase) {
      await firebase
        .firestore()
        .collection("fechas")
        .doc(`${this.props.selectedNote.id}idPAD`)
        .set({
          text: `Caso ${this.props.selectedNote.title} Fecha de Presentacion de Amparo`,
          caso: this.props.selectedNote.title,
          cliente: this.props.selectedNote.body,
          ramo: this.props.selectedNote.ramo,
          institucion: this.props.selectedNote.aseguradora,
          tipoRecl: this.props.selectedNote.tiposeguro,
          asunto: this.props.selectedNote.asunto,
          etapa: this.props.selectedNote.etapa,
          fecha: this.state.fechaPADatabase,
          timestamp: firebase.firestore.FieldValue.serverTimestamp()
        });
    }
    await firebase
      .firestore()
      .collection("notes")
      .doc(this.props.selectedNote.id)
      .update({
        fase3O: {
          numExped: this.state.numExped,
          nombNumJuz: this.state.nombNumJuz,
          tribunal: this.state.tribunal,
          fechaPrestDem: this.state.fechaPrestDem,
          fechaPrestDemP: this.state.fechaPrestDemP,
          coment1: this.state.coment1,
          fechaRadicDem: this.state.fechaRadicDem,
          fechaRadicDemP: this.state.fechaRadicDemP,
          coment2: this.state.coment2,
          fechaEmplazam: this.state.fechaEmplazam,
          fechaEmplazamP: this.state.fechaEmplazamP,
          coment3: this.state.coment3,
          fechaContestDem: this.state.fechaContestDem,
          fechaContestDemP: this.state.fechaContestDemP,
          coment4: this.state.coment4,
          fechaAdmisConte: this.state.fechaAdmisConte,
          fechaAdmisConteP: this.state.fechaAdmisConteP,
          coment5: this.state.coment5,
          fechaContVistaConte: this.state.fechaContVistaConte,
          fechaContVistaConteP: this.state.fechaContVistaConteP,
          coment6: this.state.coment6,
          fechaAdmisConteVist: this.state.fechaAdmisConteVist,
          fechaAdmisConteVistP: this.state.fechaAdmisConteVistP,
          coment7: this.state.coment7,
          fechaAudiePrelim: this.state.fechaAudiePrelim,
          fechaAudiePrelimP: this.state.fechaAudiePrelimP,
          coment8: this.state.coment8,
          fechaPDConfesional: this.state.fechaPDConfesional,
          fechaPDTestimonial: this.state.fechaPDTestimonial,
          fechaPDDecParte: this.state.fechaPDDecParte,
          fechaPDDecTercero: this.state.fechaPDDecTercero,
          fechaPDPericial: this.state.fechaPDPericial,
          fechaPDInspJudic: this.state.fechaPDInspJudic,
          fechaPDRecHechos: this.state.fechaPDRecHechos,
          fechaPDRatifContFir: this.state.fechaPDRatifContFir,
          fechaAudieJuicio: this.state.fechaAudieJuicio,
          fechaAudieJuicioP: this.state.fechaAudieJuicioP,
          coment9: this.state.coment9,
          fechaPD2Confesional: this.state.fechaPD2Confesional,
          fechaPD2Testimonial: this.state.fechaPD2Testimonial,
          fechaPD2DecParte: this.state.fechaPD2DecParte,
          fechaPD2DecTercero: this.state.fechaPD2DecTercero,
          fechaPD2Pericial: this.state.fechaPD2Pericial,
          fechaPD2InspJudic: this.state.fechaPD2InspJudic,
          fechaPD2RecHechos: this.state.fechaPD2RecHechos,
          fechaPD2RatifContFir: this.state.fechaPD2RatifContFir,
          fechaSentencia: this.state.fechaSentencia,
          fechaSentenciaP: this.state.fechaSentenciaP,
          coment10: this.state.coment10,
          fechaPrestAmpar: this.state.fechaPrestAmpar,
          fechaPrestAmparP: this.state.fechaPrestAmparP,
          coment11: this.state.coment11,
          fechaEjecuAmpar: this.state.fechaEjecuAmpar,
          fechaEjecuAmparP: this.state.fechaEjecuAmparP,
          coment12: this.state.coment12,
          fechaCumplim: this.state.fechaCumplim,
          fechaCumplimP: this.state.fechaCumplimP,
          coment13: this.state.coment13,
          resumenResol: this.state.resumenResol,
          resumenResolP: this.state.resumenResolP,
          fechaCumplim2: this.state.fechaCumplim2,
          fechaCumplim2P: this.state.fechaCumplim2P,
          coment14: this.state.coment14,
          otrosResum: this.state.otrosResum,
          otrosResumP: this.state.otrosResumP
        },
        etapa: "3-Oral",
        descr: this.state.descr,
        actualizado: this.props.selectedNote.name,
        filterEjecAmp: this.state.filterEjecAmp,
        filterCitaSent: this.state.filterCitaSent,
        timestamp: firebase.firestore.FieldValue.serverTimestamp()
      });
    this.handleClick();
  };

  onChangeHandler = async event => {
    console.log("do yu een come here brp?");
    const gui = event.target.id;
    console.log(event.target.files[0]);
    console.log(this.state.archivo);

    await this.setState({ archivo: event.target.files[0] });
    console.log(this.state.archivo);
    console.log(this.state.archivo.name);
    console.log(gui);

    const arch = this.state.archivo;
    const name = arch.name;
    let metadata = {
      contentType: "document/pdf"
    };

    const storageRef = firebase.storage().ref(this.props.selectedNote.id);
    let uploadTask = storageRef
      .child(gui + "/" + arch.name)
      .put(arch, metadata);
    let dele = this.props.selectedNote.id + "/" + gui + "/" + arch.name;

    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      function(snapshot) {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log("Upload is " + progress + "% done");
        /*  () => {
          this.setState({ open2: true });
        };*/
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log("Upload is paused");
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log("Upload is running");

            //setTimeout(function() {w.close();}, 5000)
            break;
        }
        /* () => {
          this.setState({ open2: false });
        };*/
      },
      function(error) {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case "storage/unauthorized":
            // User doesn't have permission to access the object
            console.log("User doesnt have permission to access the object");
            break;

          case "storage/canceled":
            // User canceled the upload
            console.log("User canceled the upload");
            break;

          case "storage/unknown":
            // Unknown error occurred, inspect error.serverResponse
            console.log("Unknown error occurred, inspect error.serverResponse");
            break;
        }
      },
      () => {
        // Upload completed successfully, now we can get the download URL
        uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
          console.log("File available at", downloadURL);
          // console.log("antes del push", archivos);
          const b = { downloadURL, gui, name };
          //this.setState({archivoState: downloadURL })
          //this.state[gui].push(this.state.archivoState); //LLENADO DE LA VARIABLE CON LO QUE SE VA SUBIENDO AL MOMENTO

          switch (gui) {
            case "fechaPrestDemP":
              this.setState(prevState => ({
                fechaPrestDemP: [
                  ...prevState.fechaPrestDemP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "fechaRadicDemP":
              this.setState(prevState => ({
                fechaRadicDemP: [
                  ...prevState.fechaRadicDemP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "fechaEmplazamP":
              this.setState(prevState => ({
                fechaEmplazamP: [
                  ...prevState.fechaEmplazamP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "fechaContestDemP":
              this.setState(prevState => ({
                fechaContestDemP: [
                  ...prevState.fechaContestDemP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "fechaAdmisConteP":
              this.setState(prevState => ({
                fechaAdmisConteP: [
                  ...prevState.fechaAdmisConteP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "fechaContVistaConteP":
              this.setState(prevState => ({
                fechaContVistaConteP: [
                  ...prevState.fechaContVistaConteP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "fechaAdmisConteVistP":
              this.setState(prevState => ({
                fechaAdmisConteVistP: [
                  ...prevState.fechaAdmisConteVistP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "fechaAudiePrelimP":
              this.setState(prevState => ({
                fechaAudiePrelimP: [
                  ...prevState.fechaAudiePrelimP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "fechaAudieJuicioP":
              this.setState(prevState => ({
                fechaAudieJuicioP: [
                  ...prevState.fechaAudieJuicioP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "fechaSentenciaP":
              this.setState(prevState => ({
                fechaSentenciaP: [
                  ...prevState.fechaSentenciaP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "fechaPrestAmparP":
              this.setState(prevState => ({
                fechaPrestAmparP: [
                  ...prevState.fechaPrestAmparP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "fechaEjecuAmparP":
              this.setState(prevState => ({
                fechaEjecuAmparP: [
                  ...prevState.fechaEjecuAmparP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "fechaCumplimP":
              this.setState(prevState => ({
                fechaCumplimP: [
                  ...prevState.fechaCumplimP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "resumenResolP":
              this.setState(prevState => ({
                resumenResolP: [
                  ...prevState.resumenResolP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "fechaCumplim2P":
              this.setState(prevState => ({
                fechaCumplim2P: [
                  ...prevState.fechaCumplim2P,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;
            case "otrosResumP":
              this.setState(prevState => ({
                otrosResumP: [
                  ...prevState.otrosResumP,
                  { nombre: name, url: downloadURL, bucket: dele }
                ]
              }));
              break;

            default:
              alert("algo salio mal");
          }
          this.save();
        });
      }
    );
  };
}
export default Etapa3Oral;
